import {
  AspectRatio,
  BackgroundImage,
  Badge,
  ButtonMantine,
  DEFAULT_BRAND_IMAGE,
  Flex,
  Group,
} from 'ui';
import { IconShare } from 'ui/Icons';

import classes from './EventTicket.module.css';

interface EventHeader {
  eventThumbnail?: string;
  totalTickets?: number;
  ticketNumber?: number;
  isExpired?: boolean;
  isUsed?: boolean;
  isDeleted?: boolean;
  onShareTicket?: () => void;
}

const EventTicketHeader = ({
  eventThumbnail = DEFAULT_BRAND_IMAGE,
  totalTickets,
  ticketNumber,
  isExpired,
  isUsed,
  isDeleted,
  onShareTicket,
}: EventHeader) => {
  return (
    <AspectRatio ratio={2 / 1} className={classes.EventTicket__header}>
      <BackgroundImage radius={12} src={eventThumbnail} />

      <Group className={classes.EventTicket__tags}>
        {!!totalTickets && !!ticketNumber && (
          <Badge
            size="md"
            type="neutral"
            styles={{
              label: {
                textTransform: 'none',
              },
            }}
          >
            {`Ticket ${ticketNumber} of ${totalTickets}`}
          </Badge>
        )}

        {isExpired && (
          <Badge size="md" type="warning" variant="filled">
            Expired
          </Badge>
        )}

        {isUsed && (
          <Badge size="md" type="warning" variant="filled">
            Used Ticket
          </Badge>
        )}

        {isDeleted && (
          <Badge size="md" type="error" variant="filled">
            Refunded
          </Badge>
        )}
      </Group>

      {!(isExpired || isUsed) && !!onShareTicket && (
        <Flex className={classes.EventTicket__cta}>
          <ButtonMantine
            size="sm"
            onClick={onShareTicket}
            variant="white"
            color="gray"
            rightSection={<IconShare size="16px" />}
          >
            Share Ticket
          </ButtonMantine>
        </Flex>
      )}
    </AspectRatio>
  );
};

export default EventTicketHeader;
